import { currencyFormatPartial } from '../../AlgoliaQuerySelector/utils/common'
import {
  ConfiguredFacet,
  FacetOption,
  SanitiseValuesArgs,
  SiteCode,
  SortConfig,
  SortConfigBySite,
  ValueOption,
} from '../common/types'

const SITE_INDEX_MAP: { [key: string]: string } = {
  UK: 'dev_product_uk',
  IE: 'dev_product_ie',
}

export const resolveSiteIndexMap = (params: any): Record<SiteCode, string> => {
  const configuredMap = params?.indexBySite || {}
  return {
    UK: configuredMap.UK || configuredMap.uk || SITE_INDEX_MAP.UK,
    IE: configuredMap.IE || configuredMap.ie || SITE_INDEX_MAP.IE,
  }
}

export const resolveConfiguredFacets = (params: any): FacetOption[] => {
  const facets = (params?.facets || []) as ConfiguredFacet[]

  if (!Array.isArray(facets) || !facets.length) {
    return []
  }

  return facets
    .filter((facet) => facet?.attribute)
    .map((facet) => ({
      label: facet.name || facet.attribute,
      attribute: facet.attribute,
      component: facet.component || 'terms',
    }))
}

export const getRangeValue = (start?: number, end?: number) => {
  if (typeof start === 'number' && typeof end === 'number') {
    return `${start}:${end}`
  }

  if (typeof start === 'number') {
    return `${start}:`
  }

  if (typeof end === 'number') {
    return `:${end}`
  }

  return ''
}

export const generatePriceRangeOptions = (currency = 'GBP'): ValueOption[] => {
  const ranges = [
    { start: 0, end: 49.99 },
    { start: 50, end: 75 },
    { start: 75, end: 100 },
    { start: 100, end: 150 },
    { start: 150 },
  ]

  return ranges.map((range) => ({
    value: getRangeValue(range.start, range.end),
    label: range.end
      ? `${currencyFormatPartial(range.start || 0, 2, currency)} - ${currencyFormatPartial(range.end, 2, currency)}`
      : `${currencyFormatPartial(range.start || 76, 2, currency)}+`,
  }))
}

export const resolveSortConfigForSite = (params: any, site: SiteCode): SortConfig => {
  const sortConfigBySite = (params?.sortConfigBySite || {}) as SortConfigBySite
  const siteSortConfig = sortConfigBySite[site] || sortConfigBySite[site.toLowerCase() as 'uk' | 'ie']

  if (siteSortConfig && Array.isArray(siteSortConfig.items) && siteSortConfig.items.length) {
    return siteSortConfig
  }

  return (params?.sortConfig || {}) as SortConfig
}

export const sanitiseValuesForFacet = ({
  facetName,
  currentValues,
  availableValues,
  configuredFacets,
}: SanitiseValuesArgs) => {
  const availableValueSet = new Set(availableValues.map((valueOption) => valueOption.value))
  const selectedFacet = configuredFacets.find((facet) => facet.attribute === facetName)
  const isSingleFacet = selectedFacet?.component === 'sort' || selectedFacet?.component === 'price'
  const validValues = currentValues.filter((value) => availableValueSet.has(value))

  return isSingleFacet ? validValues.slice(0, 1) : validValues
}
